export default __webpack_public_path__ + "static/real-time-data-updates-26a26f80120d712bc6a1da925b343b9a.png";